import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface StoryState {
  questionId: string | null;
  setQuestionId: (questionId: string | null) => void;
  questionTitle: string | null;
  setQuestionTitle: (questionTitle: string | null) => void;
  storyId: string | null;
  setStoryId: (storyId: string | null) => void;
  clearStoryData: () => void;
}

export const useStoryStore = create<StoryState>()(
  persist(
    (set) => ({
      questionId: null,
      setQuestionId: (questionId: string | null) => set({ questionId }),
      questionTitle: null,
      setQuestionTitle: (questionTitle: string | null) =>
        set({ questionTitle }),
      storyId: null,
      setStoryId: (storyId: string | null) => set({ storyId }),
      clearStoryData: () =>
        set({ questionId: null, questionTitle: null, storyId: null }),
    }),
    {
      name: 'story-storage',
    }
  )
);
